import { render, staticRenderFns } from "./ViewList.vue?vue&type=template&id=58b3b5cd"
import script from "./ViewList.vue?vue&type=script&lang=ts"
export * from "./ViewList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b3b5cd')) {
      api.createRecord('58b3b5cd', component.options)
    } else {
      api.reload('58b3b5cd', component.options)
    }
    module.hot.accept("./ViewList.vue?vue&type=template&id=58b3b5cd", function () {
      api.rerender('58b3b5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ViewList.vue"
export default component.exports